import { Reveal, Label } from "./Reveal";
import { PROCESS, TRUST } from "../data";

export default function Manifesto() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-obsidian py-24 lg:py-32 border-b border-border"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-12 lg:gap-x-16">
          <div className="lg:col-span-4">
            <Reveal>
              <Label>The Method</Label>
              <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95] text-white">
                A discipline,<br />not a task.
              </h2>
              <p className="mt-8 text-zinc-400 font-light leading-relaxed max-w-sm">
                Three principles govern every contract we run. This is how we
                keep the biggest names in Brisbane immaculate, night after night.
              </p>

              <ul className="mt-10 space-y-3">
                {TRUST.map((t) => (
                  <li
                    key={t}
                    className="flex items-start gap-3 text-sm text-zinc-300"
                  >
                    <span className="w-1.5 h-1.5 bg-acid mt-2 shrink-0" />
                    {t}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <div className="lg:col-span-8 lg:border-l lg:border-border lg:pl-16">
            <div className="flex flex-col">
              {PROCESS.map((p, i) => (
                <Reveal key={p.num} delay={i * 0.1}>
                  <div className="group grid grid-cols-1 md:grid-cols-12 gap-4 py-10 border-t border-border first:border-t-0 md:first:border-t">
                    <div className="md:col-span-2">
                      <span className="font-display text-5xl lg:text-6xl text-acid">
                        {p.num}
                      </span>
                    </div>
                    <div className="md:col-span-4">
                      <h3 className="font-display uppercase text-2xl lg:text-3xl text-white tracking-tight">
                        {p.title}
                      </h3>
                    </div>
                    <div className="md:col-span-6">
                      <p className="text-zinc-400 font-light leading-relaxed">
                        {p.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
